export default {
  title: 'D2D Settings',
  items: {
    D2DMarkupPercent: {
      label: 'Mark up Percent',
      type: 'integer',
      unit: ''
    },
    D2DTimeBuffer: {
      label: 'Earliest Pickup Date',
      type: 'integer',
      unit: 'minutes'
    },
    D2DArrivalDomesticSuggestedMins: {
      label: 'Arrival Domestic Buffer',
      type: 'integer',
      unit: 'minutes'
    },
    D2DArrivalInternationalSuggestedMins	: {
      label: 'Arrival International Buffer',
      type: 'integer',
      unit: 'minutes'
    },
    D2DDepartureDomesticSuggestedMins: {
      label: 'Departure Domestic Buffer',
      type: 'integer',
      unit: 'minutes'
    },
    D2DDepartureInternationalSuggestedMins: {
      label: 'Departure International Buffer',
      type: 'integer',
      unit: 'minutes'
    },
    D2DAirportDistanceLimitMiles: {
      label: 'Nearby Airport Distance Limit',
      type: 'integer',
      unit: 'miles'
    },
    D2DForceGroundMiles: {
      label: 'Distance to Force ground booking',
      type: 'integer',
      unit: 'miles'
    },
    ForceUpdateAndroidD2DConsumerVersion: {
      label: 'Force update Android - CA',
      type: 'string',
      unit: ''
    },
    ForceUpdateIOSD2DConsumerVersion: {
      label: 'Force update IOS - CA',
      type: 'string',
      unit: ''
    },
    ForceUpdateAndroidD2DProviderVersion: {
      label: 'Force update Android - PA',
      type: 'string',
      unit: ''
    },
    ForceUpdateIOSD2DProviderVersion: {
      label: 'Force update IOS - PA',
      type: 'string',
      unit: ''
    },
    D2DFlightCancelFeeType: {
      label: 'Cancellation Fee Currency - FLIGHT',
      type: 'dropdown',
      values: ['$', '%']
    },
    D2DFlightCancelFeeValue: {
      label: 'Cancellation Fee - FLIGHT',
      type: 'integer',
      unit: 'fee'
    },
    D2DGroundCancelFeeType: {
      label: 'Cancellation Fee Currency - GROUND',
      type: 'dropdown',
      values: ['$', '%']
    },
    D2DGroundCancelFeeValue: {
      label: 'Cancellation Fee - GROUND',
      type: 'integer',
      unit: 'fee'
    },
    D2DGroundLeg1Discount: {
      label: 'Ground Leg1 Discount',
      type: 'discountField',
      fields: {
        type: {
          id: 'D2DGroundLeg1DiscountType',
          label: 'Type',
          type: 'dropdown',
          values: ['$', '%']
        },
        amount: {
          id: 'D2DGroundLeg1Discount',
          label: 'Amount',
          type: 'integer',
          unit: ''
        }
      }
    },
    D2DGroundLeg2Discount: {
      label: 'Ground Leg2 Discount',
      type: 'discountField',
      fields: {
        type: {
          id: 'D2DGroundLeg2DiscountType',
          label: 'Type',
          type: 'dropdown',
          values: ['$', '%']
        },
        amount: {
          id: 'D2DGroundLeg2Discount',
          label: 'Amount',
          type: 'integer',
          unit: ''
        }
      }
    },
    D2DGroundLeg3Discount: {
      label: 'Ground Leg3 Discount',
      type: 'discountField',
      fields: {
        type: {
          id: 'D2DGroundLeg3DiscountType',
          label: 'Type',
          type: 'dropdown',
          values: ['$', '%']
        },
        amount: {
          id: 'D2DGroundLeg3Discount',
          label: 'Amount',
          type: 'integer',
          unit: ''
        }
      }
    },
    D2DGroundLeg4Discount: {
      label: 'Ground Leg4 Discount',
      type: 'discountField',
      fields: {
        type: {
          id: 'D2DGroundLeg4DiscountType',
          label: 'Type',
          type: 'dropdown',
          values: ['$', '%']
        },
        amount: {
          id: 'D2DGroundLeg4Discount',
          label: 'Amount',
          type: 'integer',
          unit: ''
        }
      }
    },
    D2DPhoneRequire: {
      label: 'Phone Require before Flight Quote',
      type: 'boolean'
    },
    D2DSessionTimeoutSecs: {
      label: 'Session Duration',
      type: 'integer',
      unit: 'seconds'
    },
    D2DSessionWarningSecs: {
      label: 'Session Time Left - Show Warning',
      type: 'integer',
      unit: 'seconds'
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Settings/settings-config/d2d-settings.js